const SYMBOLS = {
  common: 'common', uncommon: 'uncommon', rare: 'rare', 'double rare': 'double-rare',
  'ultra rare': 'ultra-rare', 'illustration rare': 'illustration-rare', 'special illustration rare': 'special-illustration-rare',
  'hyper rare': 'hyper-rare', 'ace spec rare': 'ace-spec', 'amazing rare': 'amazing-rare',
  'shiny rare': 'shiny-rare', 'shiny ultra rare': 'shiny-ultra-rare', 'mega attack rare': 'mega-attack-rare',
  'mega hyper rare': 'mega-hyper-rare', 'black white rare': 'black-white-rare', 'futuristic rare': 'futuristic-rare',
  'classic collection': 'classic-collection', 'holo rare': 'rare', 'rare holo': 'rare',
  'holo rare vmax': 'rare-vmax', 'holo rare vstar': 'rare-vstar', 'holo rare v': 'legacy-ultra-rare',
  'rare prime': 'rare-prime', 'rare holo lv.x': 'rare-lvx', legend: 'legend', 'secret rare': 'secret-rare',
  'radiant rare': 'radiant-rare', 'rgb rare': 'rgb-rare', promo: 'promo',
};

export function RarityIcon({ rarity, era }) {
  const label = String(rarity || '').trim();
  const key = label.toLowerCase();
  let symbol = SYMBOLS[key];
  if (key === 'ultra rare' && era && !['sv', 'me'].includes(era)) symbol = 'rare';
  if (!symbol) return null; // Never invent a printed symbol for undocumented rarities.
  return <span title={label} className="inline-flex min-h-8 shrink-0 items-center px-1.5" aria-label={`Rarity: ${label}`}>
    <img src={`/images/rarities/${symbol}.png`} alt={label} className="h-3 max-w-7 object-contain" />
  </span>;
}
